/**
 * @module Model
 */

import { OrderStatusType, OrderQueueType } from '@feature/orders/shared';
import { Document } from '@feature/document-center/shared/document.model';
import { User } from '@feature/users/shared';
import { OrderQueueEntry } from '@feature/orders/shared/order-queue-entry.model';

/**
 * Class representing details of an order queue in the application.
 *
 * @class
 * @model
 */
export class OrderQueue {
	/**
	 * The unique identifier for the order queue.
	 * @type {number}
	 */
	id: number;

	/**
	 * The type of the order queue.
	 * @type {OrderQueueType}
	 */
	type: OrderQueueType;

	/**
	 * The unique identifier for the user who has created the queue.
	 * @type {number}
	 */
	creatorId: number;

	/**
	 * Details of the user who has created the queue.
	 * @type {User | undefined}
	 */
	creator?: User;

	/**
	 * Details of the source CSV document that the order queue is based on.
	 * @type {Document}
	 */
	document: Document;

	/**
	 * The type of the order queue status.
	 * @type {OrderStatusType}
	 */
	status: OrderStatusType;

	/**
	 * The unique alias of the order queue status.
	 * @todo Replace with generic enum for the Order model.
	 * @type {string}
	 */
	statusAlias: string;

	/**
	 * Flag indicating whether the order queue has been processed.
	 * @type {boolean}
	 */
	isProcessed: boolean;

	/**
	 * Array of entries associated with the order queue (optional).
	 * @type {Array<OrderQueueEntry> | undefined}
	 */
	entries?: Array<OrderQueueEntry>;
}
